import { lazy } from 'react';
import { MultiApp } from '@/config/context';
import { IRouteConfig } from '../types';

export const configManageRoutes = (): IRouteConfig[] => [
  {
    path: '/config-manage',
    exact: true,
    name: '配置管理',
    component: lazy(() => import('@/presentation/pages/config-manage')),
    hideInMenu: true,
    versions: [MultiApp.WOA, MultiApp.Internal],
  },
  {
    path: '/config-manage',
    exact: true,
    name: '配置管理',
    component: lazy(() => import('@/presentation/pages/config-manage-pro')),
    hideInMenu: true,
    versions: [MultiApp.Sgp, MultiApp.Pro, MultiApp.Dji, MultiApp.Eu],
  },
];

export default configManageRoutes;
